import { useParams } from '../../../contexts/RouterContext';

export const fossaAnalysisViewType = 'dependencies';
type ViewType = typeof fossaAnalysisViewType;
type ViewTypeParams = {
  viewType?: ViewType;
};

/**
 * Get the optional view type from the URL.
 */
const useViewType = () => {
  const { viewType } = useParams<ViewTypeParams>();

  return viewType;
};

export default useViewType;
